module.exports = __webpack_public_path__ + "img/kickbite.2033334c.png";